import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, kycAPI, profileAPI } from "services";
import { Loader } from "components";
import useUniversalStore from "store/universalStore";
import EmailVerify from "./EmailVerify";
import { toast } from "sonner";
import { useForm } from "react-hook-form";

function Profile() {

  const { userBasic, user, write } = useUniversalStore((state) => state);
  const navigate = useNavigate();

  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      phone: userBasic?.contact?.phoneNumber || user?.get("username"),
      businessName: userBasic?.business?.name || "",
      typeOfBusiness: userBasic?.business?.type || "",
      email: userBasic?.contact?.email || "",
    },
  });

  useEffect(() => {
    reset({
      phone: userBasic?.contact?.phoneNumber || user?.get("username"),
      businessName: userBasic?.business?.name || "",
      typeOfBusiness: userBasic?.business?.type || "",
      email: userBasic?.contact?.email || "",
    });
  }, [userBasic, user]);


  const fetchUserBasic = async () => {
    const userBasic = await kycAPI.getUserBasic();
    write({ userBasic });
  }

  useEffect(() => {
    if (!userBasic) {
      fetchUserBasic();
    }
  }, []);

  const saveProfile = async (data) => {

    setLoading(true);

    const payload = {
      business: {
        name: data.businessName,
        type: data.typeOfBusiness
      },
      contact: {
        phoneNumber: data.phone,
        email: data.email
      }
    }

    try {

      const result = await profileAPI.updateProfileBasics(payload);

      if (result && updatedUser) {

        write({
          userBasic: result,
          user: updatedUser
        });

      }

      toast.success("Profile updated successfully!");

    } catch (error) {

      console.error("error while updating",error)

    } finally {

      setLoading(false);
      setIsEditing(false);

    }

  }

  return (

    <div style={{ height: "100vh", overflowY: "auto" }}>
      <div className="container py-4">
        {/* Header */}
        <div className="d-flex align-items-center mb-4">
          <button
            className="btn btn-light border me-3"
            onClick={() => navigate("/")}
          >
            <i className="bi bi-arrow-left"></i>
          </button>
          <h3 className="fw-bold mb-0">
            Profile Details
          </h3>
        </div>
        {/* Form */}
        <form className="mb-5 pb-5 card p-4">
          <div className="row">
            {/* Phone */}
            <div className="col-md-6 mb-4">
              <label className="form-label fw-semibold">
                Phone Number
              </label>
              <input
                className="form-control"
                type="tel"
                {...register("phone")}
                disabled
              />
            </div>

            {/* Business Name */}
            <div className="col-md-6 mb-4">
              <label className="form-label fw-semibold">
                Business Name
              </label>
              <input
                className={`form-control ${errors.businessName ? "is-invalid" : ""}`}
                type="text"
                disabled={!isEditing || loading}
                {...register("businessName", {
                  required: "Business name is required"
                })}
              />
              {errors.businessName &&
                <div className="invalid-feedback">
                  {errors.businessName.message}
                </div>
              }
            </div>
          </div>

          <div className="row">
            {/* Business Type */}
            <div className="col-md-6 mb-4">
              <label className="form-label fw-semibold">
                Type of Business
              </label>
              <select
                className={`form-control form-select ${errors.typeOfBusiness ? "is-invalid" : ""}`}
                disabled={!isEditing || loading}
                {...register("typeOfBusiness", {
                  required: "Type of business is required"
                })}
              >
                <option value="">Select business type</option>
                <option value="services">Services</option>
                <option value="manufacturing">Manufacturing</option>
                <option value="trading">Trading</option>
              </select>
              {errors.typeOfBusiness &&
                <div className="invalid-feedback">
                  {errors.typeOfBusiness.message}
                </div>
              }
            </div>

            {/* Email */}
            <div className="col-md-6 mb-4 position-relative">
              <label className="form-label fw-semibold">
                Email Address
              </label>
              <input
                className={`form-control ${errors.email ? "is-invalid" : ""}`}
                type="email"
                disabled={!isEditing || loading}
                {...register("email", {
                  pattern: {
                    value: /^\S+@\S+\.\S+$/,
                    message: "Enter a valid email"
                  }
                })}
              />
              {errors.email &&
                <div className="invalid-feedback">
                  {errors.email.message}
                </div>
              }
              {/* <EmailVerify /> */}
            </div>
          </div>

          {/* Button */}
          <button
            type="button"
            className="btn btn-danger w-100 py-3 fw-semibold d-flex justify-content-center align-items-center"
            disabled={loading}
            onClick={!isEditing ? () => setIsEditing(true) : handleSubmit(saveProfile)}
          >
            {loading &&
              <span className="spinner-border spinner-border-sm me-2"></span>
            }
            <span className="me-2">
              {isEditing ? "Save Profile" : "Edit Profile"}
            </span>
          </button>

        </form>
      </div>
    </div>

  )

}

export default Profile;